import * as yup from 'yup'

import constants from 'constants/index'

const schema = yup.object({
  reportSelected: yup.string().required('Selecione um tipo de relatório'),
  campaignId: yup
    .object()
    .nullable()
    .when('reportSelected', {
      is: constants.phishing.REPORT_TYPES.BY_CAMPAIGN,
      then: yup
        .object()
        .nullable()
        .required('Selecione uma campanha')
        .typeError('Selecione uma campanha'),
      otherwise: yup.object().nullable(),
    }),
})

export default schema
